import { useEffect, type ReactNode } from "react";
import { initFlagsClient } from "../lib/flagsClient";

/**
 * Initializes the feature-flag client (loads URL + localStorage overrides
 * synchronously, then kicks off the async Remote Config fetch). Children
 * render immediately on registry defaults; flag values update live as the
 * remote fetch resolves.
 */
export function FlagsProvider({ children }: { children: ReactNode }) {
  useEffect(() => {
    initFlagsClient();
  }, []);

  return <>{children}</>;
}
